// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__OthWA","open":"style_open__2b4uP","window":"style_window__2R73M","close":"style_close__1Of09"};